import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import type { StoreOrderDetail } from '@tailorcast/shared-types';

export function useOrderDetail(id: string | undefined) {
  const { isBitrix24 } = useBitrix24();
  const { data: telegramStatus } = useTelegramStatus();

  return useQuery({
    queryKey: ['store-order', id],
    queryFn: () => api.get<StoreOrderDetail>(BITRIX_STORE.ORDER_DETAIL(id!)),
    enabled: !!id && isBitrix24 && telegramStatus?.linked === true,
  });
}
